import styles from './LinearProgress.module.scss';

type Props = {
  value?: number;
};

export function LinearProgress({ value }: Props) {
  return <progress className={styles.linearProgress} value={value} />;
}
